import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgTreatmentPlanIconSecondary from './svgs/TreatmentPlanIconSecondary.js';
import SvgTreatmentPlanIcon from './svgs/TreatmentPlanIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var treatmentPlanIcon = (props => useIcon(SvgTreatmentPlanIcon, SvgTreatmentPlanIconSecondary, props));

export { treatmentPlanIcon as default };
